import { lazy } from 'react';

const DaftarAnggaran = lazy(() => import('./anggaran/DaftarAnggaran'));
const DaftarKategoriAnggaran = lazy(() => import('./anggaran/DaftarKategori'));
const EditKategoriAnggaran = lazy(() => import('./anggaran/EditKategori'));
const EditAnggaran = lazy(() => import('./anggaran/EditAnggaran'));
const DaftarBelanja = lazy(() => import('./belanja/DaftarBelanja'));
const EditBelanja = lazy(() => import('./belanja/EditBelanja'));
const DaftarKategoriBelanja = lazy(() => import('./belanja/DaftarKategori'));
const EditKategoriBelanja = lazy(() => import('./belanja/EditKategori'));
const TambahBelanja = lazy(() => import('./belanja/TambahBelanja'));
const TambahAnggaranPendapatan = lazy(() => import('./anggaran/TambahAnggaran'));
const TambahKategoriPendapatan = lazy(() => import('./anggaran/TambahKategori'));
const TambahKategoriBelanja = lazy(() => import('./belanja/TambahKategori'));

export {
    DaftarAnggaran,
    DaftarKategoriAnggaran,
    DaftarBelanja,
    DaftarKategoriBelanja,
    TambahAnggaranPendapatan,
    TambahBelanja,
    TambahKategoriBelanja,
    EditKategoriAnggaran,
    TambahKategoriPendapatan,
    EditAnggaran,
    EditBelanja,
    EditKategoriBelanja,
};
